// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var Api = {
  name: "ProfileAvatarContext"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(Api);

var use = include.use;

function ProfileAvatarContext(props) {
  var fetchAvatars = Curry._1(use, undefined);
  var match = React.useState(function (param) {
        
      });
  var setAvatars = match[1];
  var avatarIds = match[0];
  React.useEffect((function (param) {
          var queryAvatars = async function (param) {
            var avatarIds = await Curry._1(fetchAvatars, 3);
            return Curry._1(setAvatars, (function (param) {
                          return avatarIds;
                        }));
          };
          queryAvatars();
        }), []);
  if (avatarIds !== undefined) {
    return Curry._1(props.children, avatarIds);
  } else {
    return props.loading;
  }
}

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var make = ProfileAvatarContext;

export {
  Api ,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
  make ,
}
/* include Not a pure module */
